// ========================================
// COMPOSANT StatsCard
// Carte de statistique pour le dashboard
// ========================================

import React from 'react';
import './StatsCard.css';

const StatsCard = ({ 
  icon: Icon, 
  value, 
  label, 
  trend = null, 
  trendValue = null,
  color = 'blue' 
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return '↑';
    if (trend === 'down') return '↓';
    return null;
  };

  return (
    <div className="stat-card">
      <div className={`stat-card-icon ${color}`}>
        {Icon && <Icon />}
      </div>
      
      <div className="stat-card-content">
        <div className="stat-card-value">{value}</div>
        <div className="stat-card-label">{label}</div>
        
        {trend && trendValue && (
          <div className={`stat-card-trend ${trend}`}>
            <span className="trend-icon">{getTrendIcon()}</span>
            <span className="trend-value">{trendValue}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;